import { StyleSheet } from 'lib/paypalphrodite'
import * as media from '../../lib/styles/media-queries'
import { isDw2Repaint } from 'experiments/dw2Repaint'
import { BOX_BORDER_STYLES } from 'lib/styles/styles'

const VXLighterGrey = '#F5F7FA'
const VXLightGrey = '#CBD2D6'
const VXBorderOverride = '#9DA3A6'

export default StyleSheet.create({
  fundingOptionsWrapper: {
    overflow: 'initial',
  },
  headerWrapper: {
    marginBottom: isDw2Repaint() ? 0 : 40,
  },
  header: {
    margin: '0px auto 25px',
  },
  pageWrapper: {
    padding: 50,
    maxWidth: isDw2Repaint() ? media.SIZE_GREY_BACKGROUND : 500,
    margin: '40px auto 0',
    background: 'white',
    border: '1px solid #f2f2f2',
    [media.smallAndSmaller]: {
      padding: '30px 25px 25px',
      marginTop: 15,
    },
    ...(isDw2Repaint() && { ...BOX_BORDER_STYLES }),
    ':focus': {
      outline: 'none',
    },
  },
  noBorder: {
    border: 'none',
    [media.smallAndSmaller]: {
      marginTop: 0,
    },
  },
  overpanelWrapper: {
    padding: '0 20px',
    maxWidth: 500,
    margin: '0 auto 60px',
    background: 'white',
    [media.smallAndSmaller]: {
      padding: '30px 25px 25px',
      marginTop: 15,
    },
  },
  fundingOptionsListWrapper: {
    margin: 0,
    listStyle: 'none',
  },
  fundingOptionAlertWrapper: {
    margin: '0',
  },
  staggerBefore: {
    transform: 'translateY(10px)',
    opacity: 0,
  },
  staggerAfter: {
    transform: 'translateY(0)',
    opacity: 1,
    transition: 'all 300ms ease',
  },
  balanceToggleWrapper: {
    marginTop: 5,
    background: VXLighterGrey,
    padding: 15,
    borderRadius: 5,
  },
  balanceCheckbox: {
    ':before': {
      border: `1px solid ${VXBorderOverride}`,
    },
    margin: 0,
  },
  forceDisplayBlock: {
    display: 'block',
  },
  preventIncorrectLabelWrap: {
    // because the design is specific that the text of the label not wrap beneath checkbox
    display: 'inline-block',
    width: 'calc(100% - 45px)', // the full width, minus the size of checkboxes and radio buttons in VX
  },
  preferredBadge: {
    marginLeft: 42,
    padding: '1px 8px',
    background: '#eaf7e9',
    display: 'inline-block',
  },
  preferredBadgeText: {
    fontSize: 11,
    margin: 0,
  },
  newCardLink: {
    float: 'left',
  },
  showMoreCards: {
    float: 'right',
  },
  topLineSeparator: {
    marginTop: 0,
  },
  lineSeparator: {
    border: 'none',
    ...(!isDw2Repaint() && {
      borderTop: `1px dotted ${VXLightGrey}`,
      color: '#fff',
      height: 1,
      width: '100%',
    }),
  },
  dynamicSpacer: {
    border: 'none',
    margin: 0,
  },
  nextButton: {
    margin: '25px auto 0',
    display: 'block',
    width: 275,
    ':last-child': {
      marginBottom: '20px',
    },
  },
  cancelButton: {
    display: 'block',
    width: 250,
    margin: '20px auto 0',
  },
  disabledLabel: {
    cursor: 'not-allowed',
  },
  greyedOut: {
    opacity: '.3',
  },
  inlineWarningContainer: {
    margin: '0 auto 40px auto',
    maxWidth: '500px',
  },
  inlineWarningBlurb: {
    textAlign: 'center',
    marginBottom: '0.25rem',
    [media.smallAndSmaller]: {
      margin: '1rem 2.25rem 0.25rem 2.25rem',
    },
  },
  inlineWarningInfoLink: {
    display: 'block',
    margin: '0 auto',
  },
})
